import { Action } from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';
import { Reducer } from 'react';
import { ProductVariantActionState } from '../interfaces';
import {
    beginGetProductVariantLoading,
    endGetProductVariantLoading,
    updateProductVariantState
} from '../actions/get-variant';

import { doUpdatePageLoading, doUpdateProductVariantState } from './get-variant';
import { doSetPagination } from '../reducer/pagination';
import { setPagination } from '../actions/pagination';

// tslint:disable-next-line:no-any
export let productVariantsReducer: Reducer<ProductVariantActionState, Action<any>> = (state, action) => {
    switch (action.type) {
        case updateProductVariantState.type:
            return doUpdateProductVariantState(state, action.payload);
        case beginGetProductVariantLoading.type:
            return doUpdatePageLoading(state, true);
        case endGetProductVariantLoading.type:
            return doUpdatePageLoading(state, false);
        case setPagination.type:
            return doSetPagination(state, action.payload);
        default:
            return state;
    }
};
